import { boot } from 'quasar/wrappers';
import Antd from 'ant-design-vue';
//import 'ant-design-vue/dist/antd.css';  // ant version 3에서
import 'ant-design-vue/dist/reset.css'; // ant version 4에서

export default boot(({ app }) => {
  app.use(Antd);
});
